import { Container, Box, Paper, Text, Title, List, Group, Image, Center } from '@mantine/core';
import { IconCheck } from "@tabler/icons-react";
import studentImgae from '../assets/student.jpeg';

const pasos = [
  "Recibirás un correo electrónico con los detalles completos de tu preinscripción.",
  "Un asesor académico se pondrá en contacto contigo una vez confirmado el pago.",
  "Prepara tu documentación para completar el proceso de admisión."
];

const CheckoutSuccessPage = () => {
  return (
    <Container size="md" mih={'90vh'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper radius="md" shadow="md" style={{ display: 'flex', overflow: 'hidden', minHeight: 360, width: '100%' }}>
        <Box style={{ flex: 1, background: '#fff', padding: '32px 24px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Group mb={12}>
            <IconCheck size={20} color="#f20a61" />
            <Text fw={600} c="#f20a61" size="sm">Preinscripción completada</Text>
          </Group>
          <Title order={1} fw={500} size={35} mb={6}>¡Felicitaciones!</Title>
          <Text size="sm" mb={16}>
            Tu preinscripción en la <b>Universidad Abierta Interamericana</b> ha sido procesada con éxito.
          </Text>
          <Text fw={700} size="sm" mb={6}>Próximos pasos:</Text>
          <Box mb={20}>
            {pasos.map((paso, idx) => (
              <Group key={idx} align="center" mb={16} mt={10}>
                <Box className="paso-numero">{idx + 1}</Box>
                <Text size="sm" className="paso-texto">{paso}</Text>
              </Group>
            ))}
          </Box>
          <Text size="sm" c="#f20a61" mt={12} fw={600}>
            ¡Bienvenido a la UAI! El futuro sos vos.
          </Text>
        </Box>

        <Box className="success-image-section" style={{ flex: 1, position: 'relative', background: 'linear-gradient(120deg, #f20a61 0%, #8f001d 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box style={{ position: 'absolute', inset: 0, zIndex: 1, opacity: 0.55 }}>
            <Image src={studentImgae} radius={0} w="100%" h="100%" fit="cover" style={{ objectPosition: 'center' }} />
          </Box>
          <Box style={{ position: 'relative', zIndex: 2, color: '#fff', textAlign: 'center', width: '100%' }}>
            <Center>
              <IconCheck size={48} color="#fff" style={{ background: 'rgba(242,10,97,0.18)', borderRadius: '50%', padding: 10, marginBottom: 12 }} />
            </Center>
            <Title order={2} fw={700} size={24} mb={6} color="#fff">¡Proceso exitoso!</Title>
            <Text size="sm" c="#fff" fw={500}>
              Ya estás en camino para comenzar tu formación académica con nosotros
            </Text>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default CheckoutSuccessPage;
